import { useEffect, useRef, useState } from "react";
import {
  Autocomplete,
  Checkbox,
  DatePicker,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  MenuItem,
  Select,
  TextField,
} from "../../../../components";
import { value } from "../../../../helpers";
import { useFiltrosRelatoriosHandlers } from "../../components/use-filtros-relatorios-handlers";
import {
  FamiliaProdutosService,
  GrupoProdutosService,
  PessoaService,
  SubfamiliaProdutosService,
  SubgrupoProdutosService,
  SessionService,
} from "../../../../services";
import { responseErros, timeoutBuscaAutocomplete } from "../../../../utils";

const pessoaService = new PessoaService();
const grupoProdutosService = new GrupoProdutosService();
const subgrupoProdutosService = new SubgrupoProdutosService();
const familiaProdutosService = new FamiliaProdutosService();
const subfamiliaProdutosService = new SubfamiliaProdutosService();

const FormFiltroAvancadoAnaliseAbcProdutos = ({
  filtrosAvancados,
  setFiltrosAvancados,
  setFiltrosAplicadosImpressao,
  setValidationError,
}) => {
  const inputRefCliente = useRef();
  const inputRefFornecedor = useRef();
  const [grupoProdutoList, setGrupoProdutoList] = useState([]);
  const [subgrupoProdutoList, setSubgrupoProdutoList] = useState([]);
  const [familiaProdutoList, setFamiliaProdutoList] = useState([]);
  const [subfamiliaProdutoList, setSubfamiliaProdutoList] = useState([]);
  const [clienteList, setClienteList] = useState([]);
  const [fornecedorList, setFornecedorList] = useState([]);
  const [loadingAutoComplete, setLoadingAutoComplete] = useState(false);
  const empresa = new SessionService().getEmpresa();

  const {
    onChangeInput,
    onChangeDate,
    onChangeCheckbox,
    onChangeAutocomplete,
  } = useFiltrosRelatoriosHandlers(
    setFiltrosAvancados,
    setFiltrosAplicadosImpressao,
  );

  const buscarGruposProduto = () => {
    const filtros = {
      attributes: ['id', 'codigo', 'descricao'],
      disabledInclude: true,
      nonPaginated: true,
    };
    grupoProdutosService.getAll(filtros).then((result) => {
      if (!result.isAxiosError) {
        setGrupoProdutoList(result.data);
      } else {
        responseErros(result);
      }
    });
  };

  const buscarSubgruposProduto = () => {
    const filtros = {
      nonPaginated: true,
    };
    subgrupoProdutosService.getAll(filtros).then((result) => {
      if (!result.isAxiosError) {
        setSubgrupoProdutoList(result.data);
      } else {
        responseErros(result);
      }
    });
  };

  const buscarFamiliasProduto = () => {
    const filtros = {
      nonPaginated: true,
    };
    familiaProdutosService.getAll(filtros).then((result) => {
      if (!result.isAxiosError) {
        setFamiliaProdutoList(result.data);
      } else {
        responseErros(result);
      }
    });
  };

  const buscarSubfamiliasProduto = () => {
    const filtros = {
      nonPaginated: true,
    };
    subfamiliaProdutosService.getAll(filtros).then((result) => {
      if (!result.isAxiosError) {
        setSubfamiliaProdutoList(result.data);
      } else {
        responseErros(result);
      }
    });
  };

  const buscarClientes = () => {
    const filtros = {
      nonPaginated: true,
      tiposPessoaId: 1,
    };
    pessoaService.getAll(filtros).then((result) => {
      if (!result.isAxiosError) {
        setClienteList(result.data);
      } else {
        responseErros(result);
      }
    });
    setLoadingAutoComplete(false);
  };

  const buscarFornecedores = () => {
    const filtros = {
      nonPaginated: true,
      tiposPessoaId: 2,
    };
    pessoaService.getAll(filtros).then((result) => {
      if (!result.isAxiosError) {
        setFornecedorList(result.data);
      } else {
        responseErros(result);
      }
    });
    setLoadingAutoComplete(false);
  };

  const onInputChangePessoa = (event, tiposPessoaId) => {
    const inputRefMap = {
      1: {
        inputRef: inputRefCliente,
        buscar: buscarClientes,
      },
      2: {
        inputRef: inputRefFornecedor,
        buscar: buscarFornecedores,
      },
    };
    const { inputRef, buscar } = inputRefMap[tiposPessoaId] || {};
    if (
      event.key === "Enter" &&
      inputRef?.current === document.activeElement &&
      event.target?.value?.length > 2
    ) {
      setLoadingAutoComplete(true);
      const filtros = {
        nomeRazaoSocial: event.target.value,
        apelidoFantasia: event.target.value,
      };
      timeoutBuscaAutocomplete(buscar?.(filtros));
    }
  };

  useEffect(() => {
    setFiltrosAvancados({
      ...filtrosAvancados,
      classeA: 20,
      classeB: 30,
      classeC: 50,
    });

    buscarGruposProduto();
    buscarSubgruposProduto();
    buscarFamiliasProduto();
    buscarSubfamiliasProduto();
  }, []);

  const handleChangeClasse = (e, field) => {
    const novoValor = Number(e.target.value) || 0;
    const classeA =
      field === "classeA" ? novoValor : Number(filtrosAvancados?.classeA || 0);
    const classeB =
      field === "classeB" ? novoValor : Number(filtrosAvancados?.classeB || 0);
    const classeC =
      field === "classeC" ? novoValor : Number(filtrosAvancados?.classeC || 0);
    const soma = classeA + classeB + classeC;
    if (soma > 100) return;
    onChangeInput(e, field, "number");
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormControl variant="outlined" margin="normal" fullWidth>
            <Autocomplete
              id="clienteId"
              name="Cliente"
              options={clienteList}
              autoHighlight
              disablePortal
              getOptionLabel={(option) => option?.nomeRazaoSocial ?? ""}
              getOptionSelected={(option, value) =>
                option?.nomeRazaoSocial === value?.nomeRazaoSocial
              }
              loading={loadingAutoComplete}
              loadingText="Carregando"
              noOptionsText="Digite e pressione Enter"
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Cliente"
                  variant="outlined"
                  onKeyDown={(e) => onInputChangePessoa(e, 1)}
                  inputRef={inputRefCliente}
                  InputProps={{
                    ...params.InputProps,
                  }}
                />
              )}
              onChange={(e, value) =>
                onChangeAutocomplete("clienteId", value, "Cliente")
              }
              value={value.autoComplete(
                clienteList,
                filtrosAvancados?.clienteId,
              )}
            />
          </FormControl>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormControl variant="outlined" margin="normal" fullWidth>
            <Autocomplete
              id="fornecedorId"
              name="Fornecedor"
              options={fornecedorList}
              autoHighlight
              disablePortal
              getOptionLabel={(option) => option?.nomeRazaoSocial ?? ""}
              getOptionSelected={(option, value) =>
                option?.nomeRazaoSocial === value?.nomeRazaoSocial
              }
              loading={loadingAutoComplete}
              loadingText="Carregando"
              noOptionsText="Digite e pressione Enter"
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Fornecedor"
                  variant="outlined"
                  onKeyDown={(e) => onInputChangePessoa(e, 2)}
                  inputRef={inputRefFornecedor}
                  InputProps={{
                    ...params.InputProps,
                  }}
                />
              )}
              onChange={(e, value) =>
                onChangeAutocomplete("fornecedorId", value, "Fornecedor")
              }
              value={value.autoComplete(
                fornecedorList,
                filtrosAvancados?.fornecedorId,
              )}
            />
          </FormControl>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <FormControl variant="outlined" fullWidth>
            <Autocomplete
              id="grupoProdutoId"
              name="grupoProdutoId"
              options={grupoProdutoList}
              noOptionsText="Sem opções"
              autoHighlight
              disablePortal
              getOptionLabel={(option) => (option ? option.descricao : "")}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Grupo de Produto"
                  variant="outlined"
                  margin="normal"
                />
              )}
              onChange={(_, newValue) => {
                onChangeAutocomplete(
                  "grupoProdutoId",
                  newValue,
                  "Grupo de Produtos",
                );
              }}
              value={value.autoComplete(
                grupoProdutoList, 
                filtrosAvancados?.grupoProdutoId
              )}
            />
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <FormControl variant="outlined" margin="normal" fullWidth>
            <Autocomplete
              id="subgrupoProdutoId"
              name="subgrupoProdutoId"
              options={subgrupoProdutoList}
              noOptionsText="Sem opções"
              autoHighlight
              disablePortal
              getOptionLabel={(option) => (option ? option.descricao : "")}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Subgrupo de Produto"
                  variant="outlined"
                />
              )}
              onChange={(_, newValue) => {
                onChangeAutocomplete(
                  "subgrupoProdutoId",
                  newValue,
                  "Subgrupo de Produtos",
                );
              }}
              value={value.autoComplete(
                subgrupoProdutoList,
                filtrosAvancados?.subgrupoProdutoId,
              )}
            />
          </FormControl>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <FormControl variant="outlined" margin="normal" fullWidth>
            <Autocomplete
              id="familiaProdutoId"
              name="familiaProdutoId"
              options={familiaProdutoList}
              noOptionsText="Sem opções"
              autoHighlight
              disablePortal
              getOptionLabel={(option) => (option ? option.descricao : "")}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Família de Produto"
                  variant="outlined"
                />
              )}
              onChange={(_, newValue) => {
                onChangeAutocomplete(
                  "familiaProdutoId",
                  newValue,
                  "Família de Produtos",
                );
              }}
              value={value.autoComplete(
                familiaProdutoList, 
                filtrosAvancados?.familiaProdutoId
              )}
            />
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <FormControl variant="outlined" margin="normal" fullWidth>
            <Autocomplete
              id="subfamiliaProdutoId"
              name="subfamiliaProdutoId"
              options={subfamiliaProdutoList}
              noOptionsText="Sem opções"
              autoHighlight
              disablePortal
              getOptionLabel={(option) => (option ? option.descricao : "")}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Subfamília de Produto"
                  variant="outlined"
                />
              )}
              onChange={(_, newValue) => {
                onChangeAutocomplete(
                  "subfamiliaProdutoId",
                  newValue,
                  "Subfamília de Produtos",
                );
              }}
              value={value.autoComplete(
                subfamiliaProdutoList,
                filtrosAvancados?.subfamiliaProdutoId
              )}
            />
          </FormControl>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <DatePicker
            id="dataStart"
            name="Data-Start"
            label="Data Inicial"
            margin
            format="dd/MM/yyyy"
            value={value.date(filtrosAvancados?.dataStart)}
            onChange={(date) => onChangeDate("dataStart", date, "Data-Lançamento-De")}
            slotProps={{
              popper: { sx: { zIndex: 2000 } },
            }}
            setError={setValidationError}
          />
        </Grid>
        <Grid item xs={6}>
          <DatePicker
            id="dataEnd"
            name="Data-End"
            label="Data Final"
            margin
            format="dd/MM/yyyy"
            value={value.date(filtrosAvancados?.dataEnd)}
            onChange={(date) => onChangeDate("dataEnd", date, "Data-Lançamento-Até")}
            slotProps={{
              popper: { sx: { zIndex: 2000 } },
            }}
            setError={setValidationError}
          />
        </Grid>
      </Grid>
      <Divider sx={{ mt: 2, mb: 1, border: "1px solid grey" }} />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Select
            id="ordenarPor"
            name="ordenarPor"
            margin="normal"
            value={value.text(filtrosAvancados?.ordenarPor)}
            label="Ordenar Por"
            onChange={(event) => onChangeInput(event, "ordenarPor")}
            fullWidth
            SelectProps={{
              MenuProps: {
                disablePortal: true,
                PaperProps: {
                  sx: {
                    zIndex: 1600,
                  },
                },
              },
            }}
          >
            <MenuItem value={"NUMERICA"}>Numérica</MenuItem>
            <MenuItem value={"ALFABETICA"}>Alfabética</MenuItem>
            <MenuItem value={"VALOR_ACUMULADO"}>Valor acumulado</MenuItem>
          </Select>
        </Grid>
      </Grid>
      <Divider sx={{ mt: 2, mb: 1, border: "1px solid grey" }} />
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <FormControlLabel
            sx={{ mx: 0, mt: 2 }}
            label="A"
            labelPlacement="start"
            control={
              <TextField
                id="classeA"
                name="Classe-A"
                variant="outlined"
                sx={{ ml: 1, mr: 2 }}
                type="number"
                fullWidth
                value={value.text(filtrosAvancados?.classeA)}
                onChange={(e) => handleChangeClasse(e, "classeA")}
              />
            }
          />
        </Grid>
        <Grid item xs={4}>
          <FormControlLabel
            sx={{ mx: 0, mt: 2 }}
            label="B"
            labelPlacement="start"
            control={
              <TextField
                id="classeB"
                name="Classe-B"
                variant="outlined"
                sx={{ ml: 1, mr: 2 }}
                type="number"
                fullWidth
                value={value.text(filtrosAvancados?.classeB)}
                onChange={(e) => handleChangeClasse(e, "classeB")}
              />
            }
          />
        </Grid>
        <Grid item xs={4}>
          <FormControlLabel
            sx={{ mx: 0, mt: 2 }}
            label="C"
            labelPlacement="start"
            control={
              <TextField
                id="classeC"
                name="Classe-C"
                variant="outlined"
                sx={{ ml: 1, mr: 2 }}
                type="number"
                fullWidth
                value={value.text(filtrosAvancados?.classeC)}
                onChange={(e) => handleChangeClasse(e, "classeC")}
              />
            }
          />
        </Grid>
        <Grid item xs={12}>
          <FormControlLabel
            label="Apenas o que é gerado para Contas a Receber"
            labelPlacement="end"
            control={
              <Checkbox
                name="apenasGeradoContasReceber"
                checked={filtrosAvancados?.apenasGeradoContasReceber}
                onChange={(event) =>
                  onChangeCheckbox(event, "Apenas-Gerado-Contas-Receber")
                }
                color="primary"
              />
            }
          />
        </Grid>
      </Grid>
      {empresa?.moduloServico && (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <FormControlLabel
              label="Considerar Ordem de Serviço"
              labelPlacement="end"
              control={
                <Checkbox
                  name="ordemServico"
                  checked={filtrosAvancados?.ordemServico || false}
                  onChange={(event) => onChangeCheckbox(event, "Ordem-Servico")}
                  color="primary"
                />
              }
            />
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default FormFiltroAvancadoAnaliseAbcProdutos;
